import { render, staticRenderFns } from "./SellPlayerConfirmation.vue?vue&type=template&id=70ab775c&scoped=true&"
import script from "./SellPlayerConfirmation.vue?vue&type=script&lang=js&"
export * from "./SellPlayerConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SellPlayerConfirmation.vue?vue&type=style&index=0&id=70ab775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab775c",
  null
  
)

export default component.exports